export const KnowledgeBaseIcon = ({ size = "16" }: { size: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6636_6316)">
        <path
          d="M18 8.66667C18 10.196 17.2987 11.654 16.1467 12.666C15.604 13.1433 15.3333 13.888 15.3333 14.7087V16.6667H11.4927C11.7093 16.2473 11.862 15.7987 11.9387 15.3333H14V14.7087C14 14.4673 13.9833 14.2313 14.0207 14H12V8.66667C12 8.66667 12.3333 8.66667 12.6667 8.66667C13 8.66667 13.3333 8.36733 13.3333 8H14.6667C14.6667 8.86667 14.1067 9.60733 13.3333 9.884L13.3267 12.6667H14.4707C14.6787 12.2873 14.946 11.9473 15.2673 11.6647C16.1307 10.9053 16.6673 9.81267 16.6673 8.66667C16.6673 7.022 15.6393 5.56333 14.1127 4.952C13.6187 4.754 13.0993 4.66667 12.558 4.66733C12.3687 4.67067 12.1833 4.69333 12.0007 4.724C12.006 4.25267 11.938 3.80133 11.8153 3.404C12.0513 3.36467 12.2913 3.338 12.536 3.334C13.25 3.32667 13.9493 3.45 14.6087 3.714C16.644 4.52933 18.0007 6.47333 18.0007 8.666L18 8.66667ZM10.6667 4.66667V14.6667C10.6667 16.38 9.04667 18 7.33333 18C5.726 18 4.45933 17.1433 3.74067 15.5793C2.688 15.0607 2 13.976 2 12.7933C2 12.1927 2.172 11.614 2.494 11.116C2.14667 10.5787 2 9.96933 2 9.33333C2 8.61 2.218 7.61733 3.362 6.83533V6.50733C3.362 5.29333 4.238 4.368 5.51733 4.146C5.76533 2.90333 6.752 2 7.966 2C9.308 2 10.6667 2.916 10.6667 4.66667ZM9.33333 4.66667C9.33333 3.682 8.59667 3.33333 7.966 3.33333C7.20267 3.33333 6.79133 4.06933 6.79133 4.762V5.42867H6.12467C5.43667 5.42867 4.696 5.76667 4.696 6.508V7.596L4.356 7.78733C3.40933 8.32 3.334 8.92467 3.334 9.33333C3.334 9.768 3.44533 10.1853 3.722 10.5433L4.302 11.0753L3.83067 11.5667C3.51 11.9007 3.33333 12.3367 3.33333 12.7933C3.33333 13.5347 3.78533 14.1853 4.48533 14.45L4.75867 14.5533L4.868 14.824C5.36733 16.0633 6.17333 16.666 7.334 16.666C8.32467 16.666 9.334 15.6567 9.334 14.666V4.66667H9.33333Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_6636_6316">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
